import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap/esm/index";
import FooterNowApproved from "../../components/shared-ui/Footer/FooterNowApproved";
import NowApprovedForm from "../../components/NowApprovedForm/NowApprovedForm";
import NowApprovedHeroHeader from "../../components/NowApprovedHeroHeader/NowApprovedHeroHeader";
import { NavLink, Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/index";

import {
  pushNavHeaderClick,
  pushDownloadEvent,
  pushOutboundClick,
  pushLogoClick,
  pushCTAButtonClick,
  pushOutboundClickFacebookHeader
} from "../../assets/datalayerFunctions";

import "./NowApproved.scss";
import PrimaryButton from "../../components/shared-ui/Buttons/PrimaryButton";

function ITPNavigation(props) {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  let location = useLocation();
  let elementToScrollTo;
}

export default function NowApproved() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  let location = useLocation();
  let elementToScrollTo;
  return (
    <React.Fragment>
      <div className="now-approved-wrapper">

        <header className={`header ${isNavOpen ? "navOpen" : ""}`}>
          <div className="utility-nav itp-nav">
            <Container>
              <div className="menu_wrap-mobile">
                <ul>
                  <li>
                    <a href="/themes/pdf/Instructions-for-Use.pdf" className="download">Instructions for use</a>
                  </li>

                  <li><a href="/themes/pdf/prescribing-information.pdf" className="download">Prescribing information</a></li>
                </ul>
              </div>
              <ul className="d-none d-xl-flex utility-nav-wrapper justify-content-end">
                <li><a href="/themes/pdf/Instructions-for-Use.pdf" className="download">Instructions for use</a></li>
                <li><a href="/themes/pdf/prescribing-information.pdf" className="download">Prescribing information</a></li>
              </ul>
            </Container>
          </div>

          <div className="nav_wrap">
            <Container className="menu-container">
              <Row className="align-items-center justify-content-between">
                <Col xs={2} className="logo-wrapper">
                  <Link
                    to="/home/"
                    onClick={(event) => {
                      pushLogoClick(event);
                      if (
                        document
                          .querySelector(".header")
                          .classList.contains("navOpen")
                      ) {
                        setIsNavOpen(!isNavOpen);
                        document
                          .querySelector("body")
                          .classList.contains("nav-open")
                          ? document
                            .querySelector("body")
                            .classList.remove("nav-open")
                          : document
                            .querySelector("body")
                            .classList.add("nav-open");
                      }
                    }}
                  >
                    <img
                      alt="Doptelet avatrombopag Tablets Logo"
                      src="/images/doptelet-tablet-sprinkle-logo.png"
                    />
                  </Link>
                </Col>
              </Row>

              <div
                className="menu_btn"
                onClick={() => {
                  setIsNavOpen(!isNavOpen);
                  document.querySelector("body").classList.contains("nav-open")
                    ? document.querySelector("body").classList.remove("nav-open")
                    : document.querySelector("body").classList.add("nav-open");
                }}
              >
                <span className="bars">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>

                <div>Menu</div>
                <div>Close</div>
              </div>
              <a target="_blank" className="get-the-guide d-none" href="/pdf/Dr-Discussion-Guide.pdf">Get the Guide</a>
            </Container>
          </div>
        </header>

        <NowApprovedHeroHeader
          extraClass="large-hero inner-bg home-hero now-approved-hero-header"
          markup={
            <>
              <h1>
                Now approved for a new and expanded indication!
              </h1>
              <p>
                Sign up to learn how this new indication may help.
              </p>
            </>
          }
          maxWidth="525"
          bgImage={["PlateletCarnival_D.png", "PlateletCarnival_D.png"]}
          bgImageMobile={[
            "now-approved-hero-mobile@2x.png",
            "now-approved-hero-mobile@2x.png",
          ]}
        />
        <div className="now-approved-content">
          <div className="now-approved-content-banner">
            <div className="now-approved-content-block">
              <div>
                <h1>
                  Now approved for a new and expanded indication!
                </h1>
                <p>
                  Sign up to learn how this new indication may help.
                </p>
              </div>
            </div>
          </div>
          <NowApprovedForm />
        </div>
        <FooterNowApproved />
      </div>
    </React.Fragment>
  );
}
